// Адреса раздела «Расчёт». Всё состояние экрана живёт в адресе: ссылка на табель объекта за
// май открывается у коллеги маем, а не его сегодняшним месяцем (правило 9).

import {
  ВИД_РАСЧЁТА_СОТРУДНИКА,
  ОТБОР_ПО,
  ОТБОР_С,
  ОТБОР_СОТРУДНИКА,
} from '@/shared/payroll/расчёт-сотрудника';

export const VIEW_SHEETS = 'sheets';
export const VIEW_TIMESHEET = 'timesheet';
export const VIEW_OFFICIAL = 'official';
/** Сводка: сколько стоит месяц и где недобор (сценарии 60, 61). */
export const VIEW_SUMMARY = 'summary';
/** Реестр долгов: тз, раздел 5.5, «Экраны: реестр долгов … карточка долга». */
export const VIEW_DEBTS = 'debts';
/** Удержания за месяц: кому сколько аванса, билетов, формы, обучения (24.09.2026). */
export const VIEW_DEDUCTIONS = 'deductions';
/**
 * Расчёт сотрудника: один человек за несколько месяцев и объектов (01.10.2026). Опознаватели
 * объявлены в общем слое: на вкладку ведут и из карточки человека.
 */
export const VIEW_SETTLEMENT = ВИД_РАСЧЁТА_СОТРУДНИКА;

/** Выбранный человек на вкладке «Расчёт сотрудника» и границы его расчёта. */
export const FILTER_EMPLOYEE = ОТБОР_СОТРУДНИКА;
export const FILTER_FROM = ОТБОР_С;
export const FILTER_TO = ОТБОР_ПО;

/** Месяц: ?f.period=2026-08. Тот же ключ, что у норматива в карточке объекта. */
export const FILTER_PERIOD = 'period';
/** Выбранный объект: ?f.site=<id>. */
export const FILTER_SITE = 'site';
/** Отбор списка объектов по названию. */
export const FILTER_QUERY = 'q';

/**
 * Сквозные отборы сводки: ?f.entity=<id>, ?f.customer=<id>.
 *
 * Тз, раздел 5.7: «Сквозные фильтры экрана: юридическое лицо, период, заказчик, объект,
 * руководитель». Объект берётся уже существующим ключом `f.site`, месяц — `f.period`: два
 * ключа под один смысл дали бы две ссылки на один экран.
 */
export const FILTER_LEGAL_ENTITY = 'entity';
export const FILTER_CUSTOMER = 'customer';
/** Тип ведомости в реестре: ?f.kind=admin — только аппарат управления, `site` — объектовые. */
export const FILTER_KIND = 'kind';

/** Отборы реестра долгов: ?f.debt=uniform, ?f.debtstate=active, ?f.open=on. */
/**
 * Какой блок сводки показать человеку сразу.
 *
 * Не отбор в обычном смысле: данные он не сужает. Нужен затем, что на сводку «Расчёта» ведут
 * РАЗНЫЕ плитки пульта — долги, недобор, к выплате, — а экран у них один и длинный. Без
 * указания, куда смотреть, переход по «Подробно» приводил человека в начало страницы, где
 * ответа на его вопрос нет: он его и не находил.
 *
 * Живёт отбором, а не якорем в адресе, потому что состояние экрана у нас целиком кодируется
 * отборами (правило 4), и второго способа передать его заводить незачем.
 */
export const FILTER_FOCUS = 'focus';
export const FOCUS_STAFFING = 'staffing';

export const FILTER_DEBT_TYPE = 'debt';
/** Вид удержания на вкладке «Удержания»: ?f.deduction=uniform. Пусто — все удержания. */
export const FILTER_DEDUCTION = 'deduction';
export const FILTER_DEBT_STATUS = 'debtstate';
export const FILTER_ONLY_OPEN = 'open';
export const ONLY_OPEN = 'on';

/** Карточка долга: история удержаний, график, состояние. Панель `?p=debt-card:<id>`. */
export const PANEL_DEBT = 'debt-card';
/**
 * Перенос остатков долгов листом из Excel: показать, что понято, записать, отменить.
 * Панель одна на всю программу, опознаватель у неё постоянный. Объявлены в общем слое: её
 * открывают и из карточки человека.
 */
export { DEBTS_TRANSFER_ID, PANEL_DEBTS_TRANSFER } from '@/shared/debts/перенос';

/**
 * Официальный период: ?f.official=<id>.
 *
 * Идентификатором, а не парой дат: границы периода считает сервер, и адрес с датами позволил бы
 * сослаться на период, которого нет. Пусто — открывается самый свежий.
 */
export const FILTER_OFFICIAL_PERIOD = 'official';
/** Отбор строк контура по состоянию: ?f.state=check_details. Сценарий 72. */
export const FILTER_ROW_STATE = 'state';

/** Панели официального контура. Значение — вид в адресе `?p=вид:id`. */
export const PANEL_TRANCHES = 'official-row';
export const PANEL_WRITS = 'official-writs';
/** Карточка человека в официальном контуре: история периодов, транши, документы (тз, 5.4.5). */
export const PANEL_OFFICIAL_EMPLOYEE = 'official-employee';
export const PANEL_REVIEW = 'official-review';
export const PANEL_IMPORT = 'official-import';

/**
 * Выбранная ведомость: ?f.sheet=<id>.
 *
 * Идентификатором, а не парой «объект + месяц»: ведомостей у объекта за месяц бывает две, если
 * человек оформлен в двух юрлицах, и адрес из пары открыл бы не ту.
 */
export const FILTER_SHEET = 'sheet';
/** Отбор реестра ведомостей по состоянию: ?f.status=draft. */
export const FILTER_STATUS = 'status';
/**
 * Есть ли в ведомостях деньги: ?f.money=payable («К выплате») или ?f.money=empty («Без денег»).
 * Пусто — все. Отбор на клиенте: ведомостей за месяц десятки, и всё нужное уже в ответе реестра.
 */
export const FILTER_MONEY = 'money';
export const MONEY_PAYABLE = 'payable';
export const MONEY_EMPTY = 'empty';
/**
 * Колонка списка свёрнута: ?f.list=off.
 *
 * В адресе, а не в памяти вкладки: у ведомости девятнадцать колонок, и человек, работающий в
 * одной, сворачивает список один раз и хочет, чтобы ссылка это помнила.
 */
export const FILTER_LIST = 'list';
export const LIST_HIDDEN = 'off';

/** Панели ведомости. Значение — вид в адресе `?p=вид:id`. */
/** Тарифная строка: часы, ставка, из чего сложилось начисление. Источник ячейки. */
export const PANEL_SHEET_ROW = 'sheet-row';
/** Человек в ведомости: каскад по шагам, официальная часть, удержания. Источник ячейки. */
export const PANEL_SHEET_PERSON = 'sheet-person';
/** Разбор замечаний ведомости. */
export const PANEL_SHEET_REVIEW = 'sheet-review';
/** Мастер массового создания ведомостей на период. */
export const PANEL_SHEET_GENERATE = 'sheet-generate';
/** Добавить человека в ведомость: поиск и выбор назначения (тз, раздел 5.4.4). */
export const PANEL_SHEET_ADD = 'sheet-add';

/** Пересчёт всех ведомостей периода и разбор того, почему остались нули. */
export const PANEL_SHEET_RECALC = 'sheet-recalc';

/**
 * Рабочий лист «чего не хватает»: тарифы пачкой.
 *
 * Опознаватель — «2026-07» либо «2026-07~объект». Разделитель волной: двоеточие в адресе
 * отделяет вид панели от её опознавателя, и второе внутри разобралось бы не туда.
 */
export const PANEL_SHEET_TARIFF = 'sheet-tariff';

/**
 * «Не попали в табель»: люди «на вахте», у которых назначение кончилось, и продление пачкой
 * (19.10.2026). Панель поверх табеля месяца.
 *
 * Опознаватель — `all` (все объекты, так открывает дело в «Делах») либо `2026-10~объект` (с
 * табеля объекта: его люди отмечены, считаются те же, что на кнопке). Разделитель волной, как у
 * листа тарифов: двоеточие в адресе отделяет вид панели от опознавателя.
 */
export const PANEL_TS_UNASSIGNED = 'ts-unassigned';
/** Опознаватель панели «Не попали в табель», когда объекта нет: все объекты, без отметок. */
export const TS_UNASSIGNED_ALL = 'all';
